export const boxTraySleevesHeroContent = {
  badge: 'Food Service Solution',
  scriptTitle: 'Our Premium',
  mainTitleLines: ['Box & Tray', 'Sleeves'],
  kicker: 'Structural Integrity & Grease Resistance',
  descriptions: [
    'Durable and grease-resistant, our box and tray sleeve paper combines structural integrity with functional design for commercial kitchen and food service packaging.',
    'From bakery counters and catering units to QSR operations, our paper preserves rigidity, supports custom sizing, and strengthens dependable bulk roll supply.',
  ],
  features: [
    'High Rigidity',
    'Grease Resistant',
    'Heat Tolerant',
    'Custom Printing',
  ],
  imagePrimary: {
    src: '/images/products/Box-Tray1 (1).png',
    alt: 'Box and tray sleeve paper material',
  },
  imageSecondary: {
    src: '/images/products/Box-Tray1 (2).png',
    alt: 'Box tray sleeve manufacturing',
  },
};
